import { getRootElement } from '@entities/helpers/get-root-element'
import { INVITATION_PSELECTOR, PAGER_PSELECTOR, PRELOADING_PSELECTOR, TOGGLER_PSELECTOR } from '@constants/chat-corner'
import EventEmitter from '@services/event-bus'
import DevicesService from '@services/device'
import CommonAPI from '@api/external/common'
import { setConfig } from '@store/config'
import { Entity, InitialConfig } from '@loctypes'

export const prepareRootContainers = (entity: Entity): void => {
  const root = getRootElement(entity)
  const fragment = document.createDocumentFragment()
  const ids = [PRELOADING_PSELECTOR, TOGGLER_PSELECTOR, PAGER_PSELECTOR, INVITATION_PSELECTOR]

  ids.forEach((id) => {
    const element = document.createElement('div')
    element.id = id
    fragment.appendChild(element)
  })

  root.append(fragment)
}

export const initialConfig = async (entity: Entity, initialConfig: InitialConfig): Promise<void> => {
  let clientConfig, overridableConfig
  const { clientKey, configClientKey } = initialConfig

  try {
    clientConfig = await CommonAPI.fetchConfig(clientKey, { type: entity })
  } catch {
    throw new Error('this "clientKey" is not valid or the request was broken. Check it out please!')
  }

  if (configClientKey) {
    try {
      overridableConfig = await CommonAPI.fetchConfig(configClientKey, { type: entity })
    } catch {
      throw new Error('this "configClientKey" is not valid or the request was broken. Check it out please!')
    }
  }

  if (overridableConfig) {
    // вставляем только messengers от clientConfig
    overridableConfig.messengers = clientConfig.messengers
    setConfig(overridableConfig)
  } else {
    setConfig(clientConfig)
  }
}

export const initialEvents = () => {
  let scroll = 0
  EventEmitter.addListener('toggle', (state) => {
    if (DevicesService.isMobile) {
      if (state === 'open') {
        scroll = document.documentElement.scrollTop
      }
      document.documentElement.style.overflow = state === 'open' ? 'hidden' : 'initial'
      document.body.style.position = state === 'open' ? 'fixed' : 'initial'
      if (state !== 'open') {
        document.documentElement.scrollTop = scroll
      }
    }
  })
}
